import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
import JYUpload from './index.vue';
import H5 from './H5/h5.vue';
import { VF_UPLOAD_ENUM } from './utils';
export default {
  group: V_FORM_ENUM.custom,
  type: 'jy-upload',
  icon: 'file-upload-field',
  label: '文件列表',
  formItemFlag: true,
  component: JYUpload,
  h5: H5,
  props() {
    return { template: () => import('./setting.vue') };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onUploadSuccess: ['file'],
      onFileRemove: ['file'],
      onAdd: ['rows'],
      onMounted: [],
      onCreated: [],
      onUploadError: ['file', 'message'],
      onTargetPanel: ['option', 'rows']
    };
  },
  getSFC: () => {
    return '<div></div>';
  },
  options: {
    name: '',
    fileType: '',
    requiredHint: ' ',
    labelHidden: false,
    labelWidth: '',
    labelWrap: false,
    required: false,
    labelAlign: '',
    disabled: false,
    position: '',
    label: '附件',
    customClass: '',
    limit: 10,
    fileMaxSize: 20480,
    columnWidth: '600px',
    // --------
    template: [],
    upload: true,
    showPanel: 0,
    selectPrjFile: true,
    selectEntFile: true,
    listStyle: "",
    btnStyle: VF_UPLOAD_ENUM.text,
    prjRoot: "",
    prjRootModule: '',
    prjRootName: "",
    isNeedTargetFolder: 0,
    fileTransferCode: 'copy',
    defaultSaveDirectory: [], // 默认目录
    templateFolderId: '',
    sameNameStrategy: 'override', // 同名策略
    dictType: '',
    defFolder: [],
    // ---------
    onUploadSuccess: "",
    onFileRemove: '',
    onMounted: '',
    onCreated: '',
    onUploadError: '',
    onInitAndUpdate: ''
  },
  setDesign: {
    fileKeys: (item) => (item.options.name)
  },
  setColumns({ isNeedTargetFolder, fileTransferCode, templateFolderId, sameNameStrategy }) {
    const json = { isNeedTargetFolder, fileTransferCode, templateFolderId, sameNameStrategy };
    return {
      extAttributeJson: JSON.stringify(json)
    };
  }
};
